import { z } from 'zod';

import { jobArchitectureGenerationInfoSchema, jobArchitectureItemSchema } from './job-architecture';

export const jobFamilyWithTypeSchemaTransformed = jobArchitectureItemSchema
    .extend({
        actions: z.object({ canEdit: z.boolean(), canReadDebugInfo: z.boolean() }).optional().default({
            canEdit: false,
            canReadDebugInfo: false,
        }),
        generationInfo: jobArchitectureGenerationInfoSchema.optional(),
    })
    .transform((jobFamily) => ({
        ...jobFamily,
        type: 'job-family' as const,
    }));

export type JobFamily = z.infer<typeof jobFamilyWithTypeSchemaTransformed>;
